//  
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const SITE_URL =
  (import.meta.env.VITE_SITE_URL as string | undefined) ?? "https://www.pluggzofficial.com";

export function formatPrice(priceCents: number | null | undefined, currency: string | null | undefined): string {
  if (!priceCents || priceCents <= 0) return "";
  const amount = priceCents / 100;
  const curr = (currency || "USD").toUpperCase();
  try {
    return new Intl.NumberFormat("en-GB", { style: "currency", currency: curr, minimumFractionDigits: 2 }).format(amount);
  } catch {
    return `${curr} ${amount.toFixed(2)}`;
  }
}
